export const shouldRenderCaptcha = (
  captchaContainer: ReturnType<typeof document.querySelector>,
): boolean => !!captchaContainer && process.env.NODE_ENV === "production";
